import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { printTicket } from '../../../../../utils/printers/Ticket';
import { printReservation } from '../../../../../utils/printers/ReservationVoucher';
import { flagPrintTicketVoucher } from '../../../../../actions';

class PrintTicketButton extends Component {
  printTicket = () => {
    const { ticket, salesSessionUserId, dispatchFlagPrintTicketVoucher } = this.props;
    dispatchFlagPrintTicketVoucher(true)
    const ticketData = ticket && typeof ticket.toJS === 'function'
      ? ticket.toJS()
      : ticket;

    if (salesSessionUserId) printReservation(ticketData);
    else printTicket(ticketData);
    setTimeout(()=>{
      dispatchFlagPrintTicketVoucher(false)
    }, 4000)
  };
  
  render() {
    const { printOnMount} = this.props
    return (
      <Button color="light" className="border" onClick={this.printTicket} disabled={printOnMount}>
        <i className={`fa ${printOnMount ? "fa-spinner" : "fa-print"}`} /> Imprimir
      </Button>
    );
  }
}

PrintTicketButton.propTypes = {
  ticket: PropTypes.instanceOf(Map).isRequired,
  salesSessionUserId: PropTypes.number,
  dispatchFlagPrintTicketVoucher: PropTypes.func.isRequired,
  printOnMount: PropTypes.bool.isRequired
};

PrintTicketButton.defaultProps = {
  salesSessionUserId: null,
};

const mapStateToProps = ({ ReservationUnit }, ownProps) => ({
  ticket: ownProps.ticket || ReservationUnit.Ticket.getIn(['current', 'content']),
  printOnMount: ReservationUnit.Ticket.getIn(['current', 'printOnMount']),
});

const mapDispatchToProps = {
  dispatchFlagPrintTicketVoucher: flagPrintTicketVoucher,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintTicketButton);
